import React, { Component } from 'react';
import { getToken } from '../../../../config/index';
import Axios from 'axios';
import toastr from 'toastr';
import Spinner from 'react-bootstrap/Spinner';

export class Question1 extends Component {
  state = {
    description: '',
    loading: true,
    edit: false,
    nextloading: false,
    ok: true,
    error: '',
  };

  handleBack = () => {
    this.props.next(20);
  };

  handleNext = () => {
    this.props.next(22);
  };

  handleInputChange = (e) => {
    e.preventDefault();
    this.setState({
      edit: true,
      [e.target.id]: e.target.value,
    });
  };

  handleSave = () => {
    if (this.state.edit) {
      this.setState({
        nextloading: true,
      });
      const data = {
        id: this.props.id,
        description: this.state.description,
      };
      Axios.post('/api/app/deep_dive/modulo6/question1', data, {
        headers: { Authorization: 'Bearer ' + getToken() },
      }).then((response) => {
        if (response.data.ok) {
          toastr.remove();
          toastr.success('Saved!');
          this.props.next(22);
        } else {
          toastr.remove();
          toastr.warning(response.data.error);
        }
        this.setState({
          nextloading: false,
        });
      });
    } else {
      this.props.next(22);
    }
  };

  componentDidMount() {
    Axios.get('/api/app/deep_dive/modulo6/question1?id=' + this.props.id, {
      headers: { Authorization: 'Bearer ' + getToken() },
    }).then((response) => {
      if (response.data.ok) {
        this.setState({
          description: response.data.data.description,
          loading: false,
        });
      } else {
        this.setState({
          ok: false,
          error: response.data.error,
        });
      }
    });
  }

  render() {
    return (
      <>
        {this.state.ok ? (
          this.state.loading ? (
            <div className="col-2 text-center mx-auto">
              <Spinner animation="border" variant="secondary" />
            </div>
          ) : (
            <>
              <p className="question-title">
                <b>Question 6.1</b>
              </p>
              <p className="mb-4">
                Thinking about how the solution set will work, how would you
                describe this “THING” (what does it do for you) to a non
                technical person who has never heard of ledger, blockchain,
                Holochain or Web3/4, say a reporter, your parents, a politician,
                a board member, shareholder or a customer. Please write a short
                paragraph below.
                <br />
                <br />
                Please watch the help video, which will prompt you to articulate
                your thing (capability set) in a way that each role or actor can
                comprehend your solution, regardless of its complexity
              </p>
              <textarea
                id="description"
                onChange={this.handleInputChange}
                defaultValue={this.state.description}
                className="description"
                placeholder="Write one sentence here"
              ></textarea>

              <hr />
              <div
                style={{
                  width: '100%',
                  justifyContent: 'space-between',
                  display: 'flex',
                }}
              >
                <button
                  className="btn my-4 p-3"
                  style={{
                    color: 'white',
                    backgroundColor: '#cea977',
                    borderRadius: '10px',
                  }}
                  onClick={this.handleBack}
                >
                  <i className="fas fa-arrow-left"></i> Back
                </button>
                <button
                  className="btn my-4 p-3"
                  style={{
                    color: 'white',
                    backgroundColor: '#cea977',
                    borderRadius: '10px',
                  }}
                  onClick={this.handleSave}
                >
                  {this.state.nextloading ? (
                    <>
                      <Spinner animation="border" variant="light" size="sm" />{' '}
                      Saving...
                    </>
                  ) : (
                    <>
                      {this.state.edit ? 'Save & Next' : 'Next'}{' '}
                      <i className="fas fa-arrow-right"></i>{' '}
                    </>
                  )}
                </button>
              </div>
            </>
          )
        ) : (
          <>
            {this.state.error}
            <div
              style={{
                width: '100%',
                justifyContent: 'space-between',
                display: 'flex',
              }}
            >
              <button
                className="btn my-4 p-3"
                style={{
                  color: 'white',
                  backgroundColor: '#cea977',
                  borderRadius: '10px',
                }}
                onClick={this.handleBack}
              >
                <i className="fas fa-arrow-left"></i> Back
              </button>
            </div>
          </>
        )}
      </>
    );
  }
}

export default Question1;
